//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const uploadconfig = {
  
  fileupload: {
    service: {
      name: 'fileupload',
      title: 'Upload File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        {id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'default',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  checkupload: {
    service:{
      name:'modemcheck',
      title:'Modem Scan',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        //{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'online',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  updateupload: {
    service:{
      name:'modemlog',
      title:'Modem Update',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        //{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'update',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  mmscommupload: {
    service: {
      name: 'mmscomm',
      title: 'MMS LCD File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:1,ops:{},off:['edit','delete']},
        //{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:1,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'mmscomm',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  orderupload: {
    service: {
      name: 'meterorder',
      title: 'MMS LCD File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        //{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'order',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

  scrapupload: {
    service: {
      name: 'meterscrap',
      title: 'MMS LCD File',
      key:'rid',
      num: false,
      fields: ['rid','fgi', 'fgn', 'fgc', 'hds','pms', 'rds', 'att', 'dcd', 'tot', 'fln', 'res', 'exi', 'sts', 'ast', 'stp'],
      params: {fgn:'Group',pgc:'Code',hds:'Headers',pms:'Parameters',rds:'Records',att:'Attachments',dcd:'Created',tot:'Total',fln:'Filename',res:'Resource',exi:'Extrainfo',sts:'Status'},
      grid: [['fgn','File Group'],['fgc','Code'],['dcd','Created'],['pms','Parameters'],['tot','Total'],['fln','Filename'],['exi','ExtraInfo'],['sts','Status'],['stp','Stamp']],
      bar: {pag:true,btn:['add','edit','del','view','man','wiz']},
      menu: {mnu:[{t:'Group',v:'fgn'},{t:'Code',v:'fgc'}],def:'fgn'},
      eform:[
        {id:'tki',label:'TrackID',type:'ai',req:0,ops:{},off:['edit','delete']},
        //{id:'fgi',label:'File Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'filegroup'}},
        {id:'rfn',label:'Reference',type:'tf',req:1,ops:{},off:['edit','delete']},
        {id:'hds',label:'Headers',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'pms',label:'Parameters',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'rds',label:'Records',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'att',label:'Attachments',type:'jf',req:0,ops:{},off:['add','edit','delete']},
        {id:'dcd',label:'Created',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'tot',label:'Total',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'fln',label:'File',type:'fu',req:0,ops:{preview:false,accept:xlsaccept}},
        {id:'res',label:'Resource',type:'df',req:0,ops:{},off:['add','edit','delete']},
        {id:'exi',label:'Extrainfo',type:'jf',req:0,ops:{}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    type: 'scrap',
    create:true,
    actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
    formatters: {grid: {pms:fjd,res:fjd,exi:fjd}, form:{pms:fjd,res:fjd,exi:fjd}}
  },

}

